<template>
  <div class="for-job-seekers" id="view">
    <hero-section
      :title="title"
      :subTitle="subTitle"
      :imageName="imageName"
      :description="description"
      :showBlueWaves3="false"
      :navIndicator="navIndicator"
    />
    <benefits-section />
    <client-stories :hasPB="true" backgroundColor="#DEF3FF"></client-stories>
    <!-- <developer-hiring-section /> -->
    <solution-section />
    <neu-footer-sektion />
  </div>
</template>

<script>
import HeroSection from '@/components/partials/HeroSection.vue';
import BenefitsSection from './Sections/BenefitsSection.vue';
import DeveloperHiringSection from './Sections/DeveloperHiringSection.vue';
import SolutionGridSection from './Sections/SolutionGrid.vue';
import NeuFooterSektion from '@/views/about/Sections/NeuFooterSektion.vue';
import ClientStories from './Sections/ClientStories.vue';

export default {
  name: 'ForHiringCompanies',
  components: {
    'hero-section': HeroSection,
    'benefits-section': BenefitsSection,
    'developer-hiring-section': DeveloperHiringSection,
    'neu-footer-sektion': NeuFooterSektion,
    'solution-section': SolutionGridSection,
    'client-stories': ClientStories,
  },
  data: () => ({
    subTitle: `Why DIGU for Businesses  <span style="color: black; "></span>`,
    title: 'Your Trusted <br/>Partner <span style="color: #FF6860;"> in Success </span>',
    imageName: 'for-hiring-companies-hero.svg',
    description: `At DIGU, we believe that strong partnerships are built on trust and a shared commitment to success. Our clients choose us not just for the positive impact we create, but because they know they can rely on our expertise, dedication, and personalized approach to achieve their goals. We're more than a service provider—we're a partner invested in your success.</span>`,
    navIndicator: [
      { text: 'Home', icon: 'fas fa-home', link: '/' },
      { text: 'For Business', link: '#' },
      { text: 'Why DIGU for Businesses', link: '' },
    ],
  }),
  created() {
    document.getElementById('loaderSection').classList.add('d-none');
  },
};
</script>